import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'CancelCampaignReservationPayload'

export const CANCEL_CAMPAIGN_RESERVATION = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation cancelCampaignReservation($id: ID!) {
    cancelCampaignReservation(input: { id: $id }) {
      campaign {
        id
      }
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
